"use client";

import { useTranslation } from "react-i18next";
import type { ApiPiece } from "@/hooks/use-projects";
import { GalleryCard } from "./gallery-card";
import { EmptyState } from "@/components/ui/empty-state";
import { ClipboardCheck } from "lucide-react";

interface GalleryGridProps {
  pieces: ApiPiece[];
  onPieceClick: (piece: ApiPiece) => void;
  onApprove?: (pieceId: string) => void;
  onReject?: (pieceId: string) => void;
  selectedPieceId?: string;
  canApprove: boolean;
}

export function GalleryGrid({ pieces, onPieceClick, onApprove, onReject, selectedPieceId, canApprove }: GalleryGridProps) {
  const { t } = useTranslation("pieces");
  if (pieces.length === 0) {
    return (
      <EmptyState
        icon={ClipboardCheck}
        title={t("pieces:grid.emptyTitle")}
        description={t("pieces:grid.emptyDescription")}
      />
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {pieces.map((piece) => (
        <GalleryCard
          key={piece.id}
          piece={piece}
          onClick={() => onPieceClick(piece)}
          onApprove={() => onApprove?.(piece.id)}
          onReject={() => onReject?.(piece.id)}
          isSelected={piece.id === selectedPieceId}
          canApprove={canApprove}
        />
      ))}
    </div>
  );
}
